import { NOT_FOUND_HEADLINE_BY_REASON } from '@schemas/error-pages'
import { m } from 'motion/react'
import { fadeSlideUp } from '../../lib/motion.ts'
import { Badge } from '../badge.tsx'
import { Button } from '../button.tsx'
import { Card, CardBody } from '../card.tsx'

// RAL-162/163: `access_revoked` deliberately doesn't use the 404 voice — no "not found" framing,
// because the object is fine and the reason is a decision, not an absence. No refusal component
// existed in this codebase yet (RAL-163 assumed one); this is a minimal, focused version scoped
// to what a 404 needs, not a generalized refusal system.
export function AccessRevoked() {
  return (
    <m.div variants={fadeSlideUp} initial="hidden" animate="visible" className="mx-auto max-w-xl">
      <Card className="border-signal-fail-border">
        <CardBody className="flex flex-col gap-5 px-8 py-9">
          <Badge variant="danger">Access removed</Badge>

          <h1 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-ink-primary">
            {NOT_FOUND_HEADLINE_BY_REASON.access_revoked}
          </h1>

          <p className="max-w-prose text-sm leading-relaxed text-ink-soft">
            An admin's decision, not yours — you didn't do anything wrong, and nothing about your own account changed.
          </p>

          <div className="flex flex-wrap items-center gap-5 border-t border-border-hairline pt-4">
            <Button as="a" href="/" variant="secondary" size="sm">
              Back to your campaigns
            </Button>
          </div>
        </CardBody>
      </Card>
    </m.div>
  )
}
